import { Box, FormControlLabel, Stack, SvgIcon, SvgIconTypeMap, Typography } from "@mui/material"
import { OverridableComponent } from "@mui/material/OverridableComponent"
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline'
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined'
import AddTaskIcon from '@mui/icons-material/AddTask'
import { IOSStyleSwitch } from "../../../shared/UI/IOSStyleSwitch/IOSStyleSwitch"
import actionsService from "../../../services/actionsService"

export type WallChartToggleType = 'direct-reports' | 'wfh' | 'enhancements'

interface WallChartTogglesProps {
  togglesSelected: {
    directReport: boolean
    wfh: boolean
    enhancements: boolean
  }
  disabled: boolean
  onToggle: (toggleType: WallChartToggleType) => void
}

interface WallChartToggleProps {
  label: string
  selected: boolean
  disabled: boolean
  onToggle: () => void
  icon: OverridableComponent<SvgIconTypeMap>
  'data-testid': string
}


function WallChartToggle({ label, selected, disabled, onToggle, icon: Icon, 'data-testid': testId }: WallChartToggleProps) {
  return (
    <FormControlLabel
      control={
        <IOSStyleSwitch
          checked={selected}
          disabled={disabled}
          data-testid={testId}
        />
      }
      label={
        <Box display="flex" alignItems="center" marginRight="16px">
          <SvgIcon component={Icon} htmlColor="black" sx={{ marginRight: "8px", fontSize: "24px" }} />
          {label}
        </Box>
      }
      labelPlacement="start"
      onClick={onToggle}
    />
  )
}

export function WallChartToggles({
  togglesSelected,
  disabled,
  onToggle
 }: WallChartTogglesProps) {
  return (
    <Stack direction="row" alignItems="center" justifyContent="center" spacing={4} width="100%">
      <Typography variant="body1" component="span" fontWeight="500" color="black">
        Show/Hide:
      </Typography>
      <WallChartToggle
        label="Direct Reports"
        selected={togglesSelected.directReport}
        disabled={disabled}
        onToggle={() => {
          actionsService.userAnalytics
            .postEvent('UIClickEvent', 'WallChartDirectReportsToggleClick', window.location.pathname, window.location.hostname)
            .catch((error: unknown) => console.error('Analytics tracking error:', error))
          onToggle('direct-reports')
        }}
        icon={PeopleOutlineIcon}
        data-testid="WallChart-DirectReports"
      />
      <WallChartToggle
        label="Enhancements"
        selected={togglesSelected.enhancements}
        disabled={disabled}
        onToggle={() => {
          actionsService.userAnalytics
            .postEvent('UIClickEvent', 'WallChartEnhancementsToggleClick', window.location.pathname, window.location.hostname)
            .catch((error: unknown) => console.error('Analytics tracking error:', error))
          onToggle('enhancements')
        }}
        icon={AddTaskIcon}
        data-testid="WallChart-Enhancements"
      />
      <WallChartToggle
        label="WFH"
        selected={togglesSelected.wfh}
        disabled={disabled}
        onToggle={() => {
          actionsService.userAnalytics
            .postEvent('UIClickEvent', 'WallChartWFHToggleClick', window.location.pathname, window.location.hostname)
            .catch((error: unknown) => console.error('Analytics tracking error:', error))
          onToggle('wfh')
        }}
        icon={HomeOutlinedIcon}
        data-testid="WallChart-WFH"
      />
    </Stack>
  )
}